import { locationIdFormat } from "@redotech/redo-ids-cockroach";
import { RedoFulfillmentToteSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const bulkCreateTotes = {
  name: "bulkCreateTotes" as const,
  input: z.object({
    quantity: z.number().min(1).max(999),
    toteGroupId: zExt.objectId().nullish(),
    locationId: locationIdFormat.schema,
  }),
  output: z.object({ totes: z.array(RedoFulfillmentToteSchema) }),
};
